import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqList } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于内容范围、更新节奏和使用方式，这里整理了被问得最多的几个问题。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2 space-y-3">
            {faqList.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-300/60"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                        <i className="ri-question-line" aria-hidden="true"></i>
                      </span>
                      <span className="font-heading text-base font-bold leading-6 text-foreground-950">
                        {item.q}
                      </span>
                    </span>
                    <span
                      className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="ml-8 text-sm leading-7 text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <aside className="rounded-lg border border-background-300/60 bg-background-50 p-6">
            <div className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-chat-smile-2-line text-xl" aria-hidden="true"></i>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">还有别的问题？</h3>
            <p className="mt-2 text-sm leading-7 text-foreground-600">
              无论是发现了不准确的信息，还是想补充一条线索，都可以直接联系我们。我们会逐条核对，并在确认后更新内容。
            </p>
            <a
              href="mailto:hi@heiliaowangbao.example.com"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-foreground-900 px-5 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
              </span>
              联系我们
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}